// components/SelectionPanel.jsx (UPDATED with term selector)

import React from 'react';
import { FaSync } from 'react-icons/fa';
import ErrorMessage from './common/ErrorMessage';

const SelectionPanel = ({
  academicYears,
  selectedAcademicYear,
  onAcademicYearChange,
  isSemesterBased,
  semesters,
  selectedSemester,
  onSemesterChange,
  terms = [],
  selectedTermId = '',
  onTermChange = () => {},
  selectedTerm,
  classes,
  selectedClassId,
  onClassChange,
  onLoadTimetable,
  isLoading,
  error,
  saveStatus,
  onResetTimetable
}) => {
  console.log('[SelectionPanel] Rendering with props:', {
    selectedAcademicYear,
    isSemesterBased,
    selectedSemester,
    selectedTermId,
    termsCount: terms.length,
    classesCount: classes.length,
    selectedClassId
  });

  return (
    <div className="bg-gray-50 p-4 rounded-lg mb-6">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">Select Class Details</h3>
      
      {error && <ErrorMessage message={error} />}
      {saveStatus && (
        <div className="mb-4 p-4 bg-green-50 border-l-4 border-green-500 text-green-700 rounded-lg">
          {saveStatus}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Academic Year */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Academic Year</label>
          <select
            value={selectedAcademicYear}
            onChange={e => {
              console.log('[SelectionPanel] Academic year changed to:', e.target.value);
              onAcademicYearChange(e.target.value);
              if (onResetTimetable) onResetTimetable();
            }}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 bg-white"
          >
            <option value="">Select Academic Year</option>
            {academicYears.map(year => (
              <option key={year._id} value={year._id}>
                {year.name}{year.label ? ` (${year.label})` : ''} 
                {year.isSemesterBased ? ' [Semester]' : ' [Term]'}
              </option>
            ))}
          </select>
        </div>
        
        {/* Semester or Term selector based on academic year type */}
        {isSemesterBased ? (
          // Semester-based: Show semester dropdown
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Semester</label>
            <select
              value={selectedSemester}
              onChange={e => {
                console.log('[SelectionPanel] Semester changed to:', e.target.value);
                onSemesterChange(e.target.value);
                if (onResetTimetable) onResetTimetable();
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 bg-white"
            >
              <option value="">Select Semester</option>
              {semesters.map(sem => (
                <option key={sem._id} value={sem._id}>
                  {sem.semesterName}
                </option>
              ))}
            </select>
          </div>
        ) : (
          // Term-based: Show term dropdown
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Term</label>
            <select
              value={selectedTermId}
              onChange={e => {
                console.log('[SelectionPanel] Term changed to:', e.target.value);
                onTermChange(e.target.value);
                if (onResetTimetable) onResetTimetable();
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 bg-white"
            >
              <option value="">Select Term</option>
              {terms.map(term => (
                <option key={term._id} value={term._id}>
                  {term.termLabel || term.termName || `Term ${term.termNumber}`}
                </option>
              ))}
            </select>
          </div>
        )}
        
        {/* Class selector */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Class</label>
          <select
            value={selectedClassId}
            onChange={e => {
              console.log('[SelectionPanel] Class changed to:', e.target.value);
              onClassChange(e.target.value);
              if (onResetTimetable) onResetTimetable();
            }}
            disabled={isSemesterBased ? !selectedSemester : !selectedTermId}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 bg-white"
          >
            <option value="">Select Class</option>
            {classes.map(cls => (
              <option key={cls._id || cls.classId} value={cls._id || cls.classId}>
                {cls.className} {cls.section ? `- ${cls.section}` : ''}
              </option>
            ))}
          </select>
          {(isSemesterBased && !selectedSemester) && (
            <p className="text-xs text-gray-500 mt-1">Select a semester first</p>
          )}
          {(!isSemesterBased && !selectedTermId) && (
            <p className="text-xs text-gray-500 mt-1">Select a term first</p>
          )}
        </div>
        
        {/* Load button */}
        <div className="flex items-end">
          <button
            onClick={onLoadTimetable}
            disabled={!selectedClassId || isLoading}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
          >
            <FaSync className={`inline mr-2 ${isLoading ? 'animate-spin' : ''}`} /> 
            {isLoading ? 'Loading...' : 'Load Timetable'}
          </button>
        </div>
      </div>

      {/* Display selected term info if applicable */}
      {selectedTerm && !isSemesterBased && (
        <div className="mt-2 text-sm text-green-600">
          Selected Term: {selectedTerm.termLabel || selectedTerm.termName || `Term ${selectedTerm.termNumber}`}
        </div>
      )}
    </div>
  );
};

export default SelectionPanel;